export const GET_SESSION_BY_BOOTH = 'GET_SESSION_BY_BOOTH';
export const SET_SESSION_BY_BOOTH = 'SET_SESSION_BY_BOOTH';
export const SET_SESSION_LOADING = 'SET_SESSION_LOADING';
export const SET_BOOTH_CURRENT_SESSION = 'SET_BOOTH_CURRENT_SESSION';
